module.exports = __webpack_public_path__ + "static/media/17UN-Women3.69e1b2dd.jpg";